/**
 * SourceBadge
 *
 * Displays a coloured pill identifying the origin of a group or membership.
 *
 * Props:
 *   source  {string}  – "photon_native" | "scim" | "google_workspace" | "manual"
 *                       Unrecognised values fall back to photon_native style.
 *   size    {"md"|"sm"} – "md" (default): larger pill used in table rows.
 *                         "sm": compact bordered pill used inside panels.
 */

const SOURCE_CONFIG = {
  photon_native: {
    label: "Photon",
    colors: "bg-fill-blue-50 text-ink-blue-600 dark:bg-fill-blue-600/20 dark:text-ink-blue-300",
    border: "border-edge-blue-200 dark:border-edge-blue-600/40",
  },
  manual: {
    label: "Photon",
    colors: "bg-fill-blue-50 text-ink-blue-600 dark:bg-fill-blue-600/20 dark:text-ink-blue-300",
    border: "border-edge-blue-200 dark:border-edge-blue-600/40",
  },
  scim: {
    label: "IdP / SCIM",
    colors: "bg-fill-green-50 text-ink-green-800 dark:bg-fill-green-600/20 dark:text-ink-green-300",
    border: "border-edge-green-200 dark:border-edge-green-600/40",
  },
  google_workspace: {
    label: "Google Workspace",
    colors: "bg-fill-hex-fff7ed text-ink-orange-700 dark:bg-fill-orange-600/20 dark:text-ink-orange-300",
    border: "border-edge-hex-fed7aa dark:border-edge-orange-600/40",
  },
};

const SIZE_CLASSES = {
  md: "text-xs px-2.5 py-1 rounded-full",
  sm: "text-[10px] px-1.5 py-0.5 rounded-full border",
};

const SourceBadge = ({ source, size = "md" }) => {
  const config = SOURCE_CONFIG[source] ?? SOURCE_CONFIG.photon_native;
  const sizeClass = SIZE_CLASSES[size] ?? SIZE_CLASSES.md;
  const borderClass = size === "sm" ? config.border : "";

  return (
    <span
      className={`inline-flex items-center font-medium ${sizeClass} ${config.colors} ${borderClass}`}
    >
      {config.label}
    </span>
  );
};

export default SourceBadge;
